// import core components
import { useRef } from "react";

// import custom components
import BlockTextImage from "@/elements/Shared/BlockTextImage";
import WhiteSquare from "@/elements/Shared/DesignComponents/WhiteSquare";
import ArrowBottom from "../Shared/SVGs/ArrowBottom";

// import styles
import styles from "./hero.module.scss";

// interface
import HeroProps from "@/interfaces/Hero/HeroProps";

export default function Hero({
  heroId,
  isSquareDesignVisible,
  isAlternativeSide = false,
  isImageInsideContainer = true,
  isArrowVisibleOnMobile = true,
  dispositionContainer,
  pageName,
  className = "",
  blockTextImageClassName = "",
  optionsAnimImages,
  data: {
    title,
    content,
    button,
    images,
    asBackgroundDegrade,
    isTextBlackOnly,
    circles,
    lottieFile,
  },
}: HeroProps) {
  const heroRef = useRef(null);

  function scrollDown() {
    window.scrollTo({
      top: heroRef.current.clientHeight,
      left: 0,
      behavior: "smooth",
    });
  }

  return (
    <div
      id={heroId}
      ref={heroRef}
      className={`hero ${
        asBackgroundDegrade ? styles._bg_degrade : styles._bg_default
      } ${styles._hero} ${className !== "" ? className : ""}`}
    >
      <BlockTextImage
        isAlternativeSide={isAlternativeSide}
        isImageInsideContainer={isImageInsideContainer}
        HtagLevel={1}
        isHero={true}
        asBackgroundDegrade={asBackgroundDegrade}
        isTextBlackOnly={isTextBlackOnly}
        button={button}
        content={content}
        title={title}
        images={images}
        circles={circles}
        asPaddingBottom={true}
        dispositionContainer={dispositionContainer}
        sectionName={pageName + "-hero"}
        className={blockTextImageClassName}
        lottieFile={lottieFile}
        optionsAnimImages={optionsAnimImages}
        margin="left"
      />

      <div
        className={`${styles._arrows} ${
          !asBackgroundDegrade ? styles._alternative : ""
        } ${!isArrowVisibleOnMobile ? styles._hidden_on_mobile : ""}`}
      >
        <span onClick={() => scrollDown()}>
          <ArrowBottom />
        </span>
      </div>

      {isSquareDesignVisible && <WhiteSquare isHidden={false} />}
    </div>
  );
}
